import { ReactNode } from "react";
import "./ManagementPanel.css";

interface Props {
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function ManagementPanel({
  title,
  actions,
  children,
  className,
}: Props) {
  const panelClassName = className
    ? `management-panel ${className}`
    : "management-panel";

  return (
    <section className={panelClassName}>
      <div className="management-panel-header">
        <h5 className="mb-0 management-panel-title">{title}</h5>
        {actions && <div>{actions}</div>}
      </div>
      {children}
    </section>
  );
}
